import { apiV2Root } from "consts";
import { useDataQueryParams } from "hooks/useDataQueryParams";
import { useFlag } from "hooks/useFlags";
import { useUser } from "hooks/useUser";

import {
  NOTIFICATIONS_QUERY_KEY,
  type NotificationsSummary,
} from "./data/types";

/** Как часто перезапрашивается счётчик, пока вкладка активна. */
export const NOTIFICATIONS_POLL_INTERVAL = 2 * 60 * 1000;

/** Сводка по уведомлениям текущего пользователя. */
export const useNotifications = () => {
  const { isLoggedIn } = useUser();
  const enabled = useFlag("notificationsTest");

  const data = useDataQueryParams<NotificationsSummary>(
    NOTIFICATIONS_QUERY_KEY,
    {},
    apiV2Root,
    !isLoggedIn || !enabled,
    {
      refetchInterval: NOTIFICATIONS_POLL_INTERVAL,
      // staleTime по умолчанию (5 минут) длиннее интервала опроса —
      // иначе данные считались бы свежими и между опросами
      staleTime: NOTIFICATIONS_POLL_INTERVAL,
    },
  );

  const channels = data?.channels ?? {};

  return {
    // Число для бейджа — агрегат по всем каналам
    count: channels.all?.count ?? 0,
    channels,
  };
};
